
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/regulatory-changes/new-law-alert",
      function () {
        return require("private-next-pages/compliance/regulatory-changes/new-law-alert/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/regulatory-changes/new-law-alert"])
      });
    }
  